import { DialogMessageComponent } from './../../dialog/dialog-message/dialog-message.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DialogApiDefinitionSettingComponent } from './../../dialog/dialog-api-definition-setting/dialog-api-definition-setting.component';
import { DialogService } from './../../service/dialog.service';
import { MODULE_NAME, FIELD_COMPONENT, Constant } from 'app/config/constants';
import { MenuActionService } from './../../service/menu-action.service';
import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { CommonTableService } from 'app/service/common-table.service';
import { CommonTable } from 'app/model/entity/commonTable';
import { UrlDetails } from 'app/model/entity/api-details';
import { GTFSManagerService } from 'app/service/gtfs-manager.service';
import { DialogTextHighlightingSettingComponent } from 'app/dialog/dialog-text-highlighting-setting/dialog-text-highlighting-setting.component';
import { CommonService } from 'app/service/common.service';
import { DataService } from 'app/service/data.service';
import { UpperLimit } from 'app/model/entity/upper-limit';
import { Helper } from 'app/common/helper';

@Component({
  selector: 'gtfs',
  templateUrl: './gtfs.component.html',
  styleUrls: ['./gtfs.component.scss']
})
export class GTFSComponent implements OnInit {
  subscriptions: Array<Subscription> = new Array<Subscription>();
  apiDetails: UrlDetails;
  isRoot: boolean;

  constructor(
    private menuActionService: MenuActionService,
    private dialogService: DialogService,
    private toast: ToastrService,
    public translateService: TranslateService,
    private commonTableService: CommonTableService,
    private gtfsManagerService: GTFSManagerService,
    private commonService: CommonService,
    private dataService: DataService
  ) {
    this.subscriptions.push(
      this.menuActionService.actionApiDefinitionSetting.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.GTFSComponent]) {
          this.apiDefinitionSetting();
        }
      })
    );

    this.subscriptions.push(
      this.menuActionService.actionUpdateApiDefinitionSetting.subscribe(module => {
        if (module == MODULE_NAME[FIELD_COMPONENT.GTFSComponent]) {
          this.updateApiGTFS();
        }
      })
    );

    // setting update text highlight
    this.subscriptions.push(
      this.menuActionService.actionUpdateTextHighlight.subscribe(moduleName => {
        if (moduleName == MODULE_NAME[FIELD_COMPONENT.GTFSComponent]) {
          this.updateTextHighlightSetting();
        }
      })
    );

    this.isRoot = this.commonService.getCommonObject().userIdString == Constant.ROOT;
    this.dataService.sendData([Constant.IS_ROOT, this.isRoot]);
  }

  private fetchApiDetail(): void {
    this.commonTableService.getValueCommonTableByKey(Constant.GTFS_KEY_API_DETAILS).subscribe((data: CommonTable) => {
      if (data) {
        this.apiDetails = JSON.parse(data.value);
      }
    });
  }

  ngOnInit(): void {
    this.fetchApiDetail();
  }

  /**
   * on destroy
   */
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public apiDefinitionSetting(): void {
    this.commonTableService.getValueCommonTableByKey(Constant.GTFS_KEY_API_DETAILS).subscribe(data => {
      this.dialogService.showDialog(
        DialogApiDefinitionSettingComponent,
        {
          data: {
            commonTable: data ?? new CommonTable(Constant.GTFS_KEY_API_DETAILS, JSON.stringify(new UrlDetails('')))
          }
        },
        result => {
          if (result) {
            this.fetchApiDetail();
          }
        }
      );
    });
  }

  private showUpdateFail(e?: any): void {
    const errMsg =
      e && e.status === Constant.NETWORK_ERROR_CODE
        ? this.translateService.instant('dialog-error.error-network-api')
        : this.translateService.instant('dialog-api-definition-setting.error');
    this.dialogService.showDialog(DialogMessageComponent, {
      data: {
        title: this.translateService.instant('dialog-error.title'),
        texts: [errMsg]
      }
    });
  }

  public updateApiGTFS(): void {
    if (!this.apiDetails || !this.apiDetails.url) {
      this.dialogService.showDialog(DialogMessageComponent, {
        data: {
          title: this.translateService.instant('dialog-error.title'),
          text: this.translateService.instant('dialog-api-definition-setting.not-api')
        }
      });
    } else {
      this.gtfsManagerService.getAllGtfsTextHighLightSetting().subscribe(
        highlighSetting => {
          let listSave = highlighSetting;
          if (!highlighSetting || !highlighSetting.length) {
            listSave = Constant.DEFAULT_TEXT_HIGHLIGHTING_SETTING.map(dataSave => Helper.convertTextHighlightToDB(dataSave));
          }

          this.gtfsManagerService.updateApiDetails(this.apiDetails.url, listSave).subscribe(
            data => {
              if (data) {
                this.toast.success(this.translateService.instant('dialog-api-definition-setting.success'), '');
              } else {
                this.showUpdateFail();
              }
            },
            e => {
              this.showUpdateFail(e);
            }
          );
        },
        e => {
          this.showUpdateFail(e);
        }
      );
    }
  }

  /**
   * update Text Highlight Setting
   */
  public updateTextHighlightSetting(): void {
    this.commonTableService.getValueCommonTableByKey(Constant.KEY_UPPER_LIMIT).subscribe(data => {
      let itemLength = Constant.TIMETABLE_ID_UPPER_LIMIT.DEFAULT;
      if (data && data.value) {
        const upperLimit: UpperLimit = JSON.parse(data.value);
        itemLength = upperLimit.timetableId;
      }

      this.dialogService.showDialog(
        DialogTextHighlightingSettingComponent,
        {
          data: {
            properties: ['time', ...Array.from({ length: itemLength + 1 }, (_, i) => 'item' + (i + 1))],
            isGtfs: true
          },
          maxHeight: '90vh'
        },
        result => {
          if (result == undefined) {
            return;
          }
        }
      );
    });
  }
}
